import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponse, PaginationResponse} from "../base/repository/entity/base.entity";
import {environment} from "../../../environments/environment";
import {Branch} from "./branch.entity";

@Injectable({
  providedIn: 'root',
})
export class BranchRepository {
  constructor(private http: HttpClient) {
  }

  fetchAllBranch() {
    return this.http.get<ApiResponse<PaginationResponse<Branch[]>>>(
      `${environment.baseUrl}/branch`
    );
  }

}
